<template style="height:100%">
  <div class="Module_management">
    <div class="Module_management_top">
      <el-form style="padding: 20px;" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="帖子名称:">
          <el-input v-model="formInline.contentName" placeholder="帖子名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="创建者:">
          <el-input v-model="formInline.creator" placeholder="创建者"></el-input>
        </el-form-item> -->
        <el-form-item label="创建时间:">
          <el-date-picker v-model="formInline.createTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属圈子">
          <el-select v-model="formInline.circleKey" placeholder="所属圈子">
            <el-option v-for="(item,i) in getallcircles" :key="i" :label="item.circleName" :value="item.circleKey"></el-option>
          </el-select>
        </el-form-item>

        <el-button type="primary" @click="inquire()">查询</el-button>
        <el-button type="primary" @click="chongzhi()">重置</el-button>
      </el-form>

    </div>

    <div style="height: 15px;width: 100%;background-color: rgb(235, 236, 237);"></div>
    <el-button type="primary" style="margin-top: 20px;margin-left: 1%;" @click="addfun()">新增帖子</el-button>
    <el-button type="primary" style="margin-top: 20px;" @click="qiyong(1)">启用</el-button>
    <el-button type="primary" style="margin-top: 20px;" @click="delfuns()">删除</el-button>
    <el-button type="primary" style="margin-top: 20px;" @click="qiyong(0)">关闭</el-button>
    <el-table ref="multipleTable"  v-loading="loading" :data="data" style="width: 98%;margin-left: 1%;margin-top: 20px;" @selection-change="handleSelectionChange" :row-key="(row) => { return row.contentKey }">
      <el-table-column type="selection" :selectable="checkSelectable" :reserve-selection="true" width="55"></el-table-column>
      <el-table-column prop="contentName" label="帖子主题"></el-table-column>
      <el-table-column prop="circleName" label="所属圈子"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="searchCount" label="浏览数量"></el-table-column>
      <el-table-column prop="commentCount" label="评论数量"></el-table-column>
      <el-table-column prop="likeCount" label="点赞数量"></el-table-column>
      <el-table-column prop="shareCount" label="转发数量"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1" style="color: #3bcb00;">启用</span>
          <span v-if="scope.row.status == 0">关闭</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="210px">
        <template slot-scope="scope">
          <span class="w" @click="weditor(scope.row)">编辑</span>
          <span class="w" @click="looks(scope.row)">查看</span>
          <span class="w" @click="delfun(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination @current-change="handleCurrentChange" :current-page.sync="formInline.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="Counts"></el-pagination>
    <el-dialog :title="tit1" :visible.sync="dialogVisible" width="900px" :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="帖子主题" prop="contentName">
          <el-input v-model="ruleForm.contentName" placeholder="请输入帖子主题"></el-input>
        </el-form-item>
        <el-form-item label="帖子说明" prop="remark">
          <el-input v-model="ruleForm.remark" placeholder="请输入帖子说明"></el-input>
        </el-form-item>
        <el-form-item label="所属圈子"  prop="circleKey">
          <el-select v-model="ruleForm.circleKey" placeholder="所属圈子">
            <el-option v-for="(item,i) in getallcircles" :key="i" :label="item.circleName" :value="item.circleKey"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="直接启用">
          <el-switch v-model="ruleForm.status"></el-switch>
        </el-form-item>
        <el-form-item label="帖子封面" prop="cover" >
          <div class="cover" style="margin-left:-70px">
            <el-upload :on-change="handleChange" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png">
              <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon">
                <span style="font-size: 16px;">点击选择封面</span>
              </i>
            </el-upload>
          </div>
          <p style="font-size: 12px;line-height: 20px;">推荐使用800X450像素的图片，或者16:9比例的.jpg/.png图片，为保证显示效果，图片应该美观、紧扣主题。</p>
        </el-form-item>

        <el-form-item label="上传图片">
          <el-upload :on-change="handleChange2" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept="image/jpeg,image/gif,image/png">
            <el-button size="small" type="primary" style="margin-left: -70px;">点击上传</el-button>
            <span style="font-size: 12px;margin-left: 20px;">推荐使用800X450像素或者16:9比例的.jpg/.png格式图片，数量不超过9张为保证 显示效果，图片应该美观、紧扣主题。</span>
          </el-upload>
          <ul class="imgul">
            <li v-for="(item,i) in ruleForm.filesimg" :key="i" style="position: relative;"> 
              <img style="position: absolute;top: 0px;left: 0px;" :src="item" alt="" >
              <div style="width: 100%;height: 20px;background-color: rgb(56, 56, 56);color: #fff;text-align: center;line-height: 20px;font-size: 12px;opacity: 0.8;z-index: 9;" @click="imgdel(item, i)">删除</div>
            </li>
          </ul>
        </el-form-item>

        <!-- <el-form-item label="上传视频">
          <el-upload :on-change="handleChange3" :auto-upload="false" class="avatar-uploader" action="" :show-file-list="false" accept=".mp4, .avi, .mov">
            <el-button size="small" type="primary" style="margin-left: -70px;">点击上传</el-button>
            <span style="font-size: 12px;margin-left: 20px;">推荐16:9比例的视频，不超过50M，为保证显示效果，视频应该、清晰美观、紧扣主题。</span>
          </el-upload>
          <div style="margin-top: 50px;">{{ ruleForm.shiMaterialPathname }}</div>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" :loading="iscontinuous" @click="submitForm('ruleForm')">{{ tit2 }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="帖子详情" :visible.sync="dialogVisible2" width="70%" :before-close="handleClose">
      <div class="Post_details">
        <img :src="tzdata.cover" alt="" style="width: 180px;height: 120px;margin-left: 20px;margin-top: 20px;">
        <h2 style="position: absolute;top: 70px;left: 240px;">{{ tzdata.contentName }}</h2>
        <p style="position: absolute;top: 120px;left: 240px;">{{ tzdata.remark }}</p>
        <ul class="csoul" style="position: absolute;top: 175px;left: 240px;">
          <li>所属圈子：{{ tzdata.circleName }}</li>
          <li>浏览量：{{ tzdata.searchCount }}</li>
          <li>点赞量：{{ tzdata.likeCount }}</li>
          <li>转发量：{{ tzdata.shareCount }}</li>
        </ul>
      </div>
      <h2 style="margin-top: 14px;font-size: 18px;">用户评论（{{ tzdata.commentCount }} 条）</h2>
      <div class="review">
        <ul style="height:100%;overflow: auto;">
          <li style="position: relative;height: 120px;" v-for="(item, i) in tzdata.comment" :key="i">
            <img style="width: 30px;height: 30px;border-radius: 50%;position: absolute;top: 10px;left: 10px;" src="https://img1.baidu.com/it/u=2971332094,2141001457&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=889" alt="">
            <p style="position: absolute;top: 17px;left: 52px;">{{ item.name }}</p>
            <p style="position: absolute;top: 50px;left: 52px;font-size: 14px;font-weight: 600;">{{ item.text }}</p>
            <p style="position: absolute;top: 80px;left: 52px;">{{ item.createTime }} <span class="w" @click="delreview(item)">删除评论</span></p>
          </li>
        </ul>
      </div>

    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iscontinuous:false,
      getallcircles: "",
      formInline: {
        pageSize: 10,
        pageIndex: 1,
        contentName: "",//帖子名称
        creator: "",//创建者
        createTime: "",//创建时间
        circleKey: ""//帖子栏目名称
      },
      ruleForm: {
        contentName: '',//帖子主题
        remark: '',//帖子说明
        circleKey: '',//所属圈子
        status: true,//直接启用
        cover: '',//帖子封面
        imageUrl: '',//封面显示
        shiMaterialPath: '',//帖子视频
        shiMaterialPathname: '',//帖子视频
        files: [],//帖子图片
        filesimg: [],//帖子显示
        contentKey:'',//帖子编号
      },
      rules: {
        contentName: [
          { required: true, message: '请输入帖子主题', trigger: 'blur' },
        ],
        remark: [
          { required: true, message: '请输入帖子说明', trigger: 'blur' },
        ],
        circleKey: [
          { required: true, message: '请选择所属圈子', trigger: 'change' }
        ],
        cover: [
          { required: true, message: '请选择帖子封面', trigger: 'blur' },
        ],
      },
      data: [],
      loading: true,
      Counts: 0,
      dialogVisible: false,
      tit1:'新增帖子',
      tit2: '立即创建',
      contentKey: [],
      bsbf: [],
      dialogVisible2: false,
      tzdata:'',
    };
  },
  components: {

  },
  methods: {
    delreview(item) {
      this.$Http_Post("/activitymanagement/deleventcomment", { commentKey: item.commentKey }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          // this.looks();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },
    addfun() {
      this.dialogVisible = true;
    },
    inquire() {
      this.load();
    },
    chongzhi(){
      this.formInline = {
        pageSize: 10,
        pageIndex: 1,
        contentName: "",//帖子名称
        creator: "",//创建者
        createTime: "",//创建时间
        circleKey: ""//帖子栏目名称
      }
      
      this.load();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.iscontinuous = true
          if (this.tit1 == '新增帖子') {
            var from = new FormData();
            from.append('cover', this.ruleForm.cover);
            from.append('shiMaterialPath', this.ruleForm.shiMaterialPath);
            this.ruleForm.files.forEach(item => {
              from.append('files', item.raw);
            })
            from.append('circleKey', this.ruleForm.circleKey);
            from.append('contentName', this.ruleForm.contentName);
            from.append('remark', this.ruleForm.remark);
            from.append('status', this.ruleForm.status ? "1" : '0');
            this.$Http_Post('/activitymanagement/addcontent', from, {}).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.iscontinuous = false
                this.Global.request_successful(res.Message);
                this.dialogVisible = false;
                this.ruleForm.files = []
                this.ruleForm = {
                  contentName: '',//帖子主题
                  remark: '',//帖子说明
                  circleKey: '',//所属圈子
                  status: true,//直接启用
                  cover: '',//帖子封面
                  imageUrl: '',//封面显示
                  shiMaterialPath: '',//帖子视频
                  shiMaterialPathname: '',//帖子视频
                  files: [],//帖子图片
                  filesimg: [],//帖子显示
                  contentKey: '',//帖子编号
                }
                this.load();
              } else {
                this.iscontinuous = false
                this.Global.request_failure(res.Message);
              }
            })
          } else {
            var from = new FormData();
            from.append('cover', this.ruleForm.cover);
            from.append('shiMaterialPath', this.ruleForm.shiMaterialPath);
            this.ruleForm.files.forEach(item => {from.append('files', item.raw)})
            from.append('circleKey', this.ruleForm.circleKey);
            from.append('contentName', this.ruleForm.contentName);
            from.append('remark', this.ruleForm.remark);
            from.append('contentKey', this.ruleForm.contentKey);
            from.append('status', this.ruleForm.status ? "1" : '0');
            from.append('contentPicKey', this.bsbf);
            this.$Http_Post('/activitymanagement/upcontent', from, {}).then((res) => {
              if (res.Code == 200 || res.Code == 0) {
                this.iscontinuous = false
                this.Global.request_successful(res.Message);
                this.dialogVisible = false;
                this.ruleForm.files = []
                this.ruleForm = {
                  contentName: '',//帖子主题
                  remark: '',//帖子说明
                  circleKey: '',//所属圈子
                  status: true,//直接启用
                  cover: '',//帖子封面
                  imageUrl: '',//封面显示
                  shiMaterialPath: '',//帖子视频
                  shiMaterialPathname: '',//帖子视频
                  files: [],//帖子图片
                  filesimg: [],//帖子显示
                  contentKey: ''//帖子编号
                }
                this.load();
              } else {
                this.iscontinuous = false
                this.Global.request_failure(res.Message);
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    load() {
      this.$Http_Post("/activitymanagement/getcontentlist",{ from: this.formInline }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data;
          this.Counts = res.Counts;
          this.loading = false;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
    handleCurrentChange(val) {
      this.formInline.pageIndex = val;
      this.load();
    },
    handleClose(done) {
      this.dialogVisible2 = false;
      this.dialogVisible = false;
    },
    handleChange(file, fileList) {
      this.ruleForm.imageUrl = URL.createObjectURL(file.raw);
      this.ruleForm.cover = file.raw;
    },
    checkSelectable(row) {
      if (row.IsSubmit == "已生成报告") {
        return true;
      } else {
        return true;
      }
    },
    handleChange2(file, fileList) {
      if (this.tit1 == '新增帖子') {
        if (this.ruleForm.files.length <= 8) {
          this.ruleForm.files = fileList;
          this.ruleForm.filesimg.push(URL.createObjectURL(file.raw));
        } else {
          this.Global.request_failure('图片数量不能超过9张！');
        }
      } else {
        if (this.ruleForm.files.length <= 8) {
          this.ruleForm.files = fileList;
          this.ruleForm.filesimg.push(URL.createObjectURL(file.raw));
        } else {
          this.Global.request_failure('图片数量不能超过9张！');
        }
      }
    },
    handleChange3(file) {
      this.ruleForm.shiMaterialPath = file.raw;
      this.ruleForm.shiMaterialPathname = file.raw.name;
    },
    imgdel(item, i) {
      this.ruleForm.filesimg.splice(i, 1);
      if (this.bsbf.length - 1 >= i) {
        this.bsbf.splice(i, 1);
      } else {
        this.ruleForm.files.splice(i - 4, 1);
      }
    },
    handleSelectionChange(val) {
      var lsc = [];
      for (var i = 0; i < val.length; i++) {
        lsc.push(val[i].contentKey);
      }
      this.contentKey = lsc;
    },
    delfun(row) {
      var from = {
        contentKeys:[row.contentKey]
      }
      this.$Http_Post("/activitymanagement/decontent", { from: from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.load();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    delfuns(row) {
      if(!this.contentKey.length>0){
        alert('请选择选项!')
        return false
      }
      var from = {
        contentKeys: this.contentKey
      }
      this.$Http_Post("/activitymanagement/decontent", { from: from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.load();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    qiyong(status) {
      if(!this.contentKey.length>0){
        alert('请选择选项!')
        return false
      }
      var from = {
        contentKeys: this.contentKey,
        status: status,
      }
      this.$Http_Post("/activitymanagement/qgcontent", { from: from }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.contentKey = [];
          this.$refs.multipleTable.clearSelection();
          this.load();
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    looks(row) {
      this.dialogVisible2 = true;
      this.aaa = row.contentKey;
      this.$Http_Post('/activitymanagement/getcontentxq', { contentKey: row.contentKey, pageIndex: 1, pageSize: 10 }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tzdata = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },

    weditor(row) {
      this.ruleForm.contentKey = row.contentKey;
      this.tit1 = '修改帖子';
      this.tit2 = '确定修改';
      this.dialogVisible = true;
      this.ruleForm.filesimg = [];
      this.ruleForm.files = [];
      this.$Http_Post('/activitymanagement/getcontentxq', { contentKey: row.contentKey, pageIndex: 1, pageSize: 10 }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.ruleForm.contentName = res.Data.contentName;//帖子主题
          this.ruleForm.remark = res.Data.remark;//帖子说明
          this.ruleForm.circleKey = res.Data.circleKey;//所属圈子
          this.ruleForm.status = res.Data.status == 1 ? true : false;//直接启用
          this.ruleForm.cover = res.Data.cover;//帖子封面
          res.Data.contentPic.forEach(item, i => {
            if (item.materialStates == 0) {
              this.ruleForm.filesimg.push(item.materialPath);
              this.bsbf.push(item.contentPicKey);
            } else if (item.materialStates == 1) {
              this.ruleForm.shiMaterialPathname = item.materialPath;
            }
          })

        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
  mounted() {
    this.load();
    this.$Http_Post('/activitymanagement/getallcircles').then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.getallcircles = res.Data;
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  }
};
</script>
<style>
  .Module_management {width: 100%;height: 100%;background-color: #fff;}
  .Module_management .imgul {margin-top: 50px;}
  .Module_management .imgul li{width: 120px;height: 80px;background-color: aqua;float: left;margin-left: 10px;margin-top: 10px;}
  .Module_management .imgul li img{width: 100%;height: 100%;}
  .Module_management .avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 215px;height: 148px;line-height: 148px;text-align: center;border: 1px solid #d1d1d1;}
  .avatar {width: 215px;height: 148px;display: block;}
  .cover {margin-left: 10px;font-size: 14px;vertical-align: middle;box-sizing: border-box;position: relative;color: #606266;height: 150px;}
  .Module_management .avatar-uploader {position: absolute;top: 0px;left: 70px;}
  .cover p {font-size: 14px;color: rgba(158, 158, 158, 1);position: absolute;top: 0px;left: 297px;width: 350px;}
  .scale {margin-top: 30px;}
  .Module_circle_details .Post_details{height: 160px;position: relative;border-bottom: 1px solid #cbc6c6;}
  .review{width: 100%;height: 600px;border: 1px solid #cbc6c6;margin-top: 20px;}
  .post_details_top_right .csoul{position: absolute;top: 120px;left: 300px;}
  .csoul li{float: left;width: 120px;}
</style>